import { Spacer, Text } from "@chakra-ui/react"

export default function LostAndFound(){
    return(
        <div style={{ display:"flex", flexDirection:"column",alignItems:"center", justifyContent:"center", alignSelf:"center"}}>
        <Text >
            Is this the place,
            <br/>where I lost the fear.
            <br/>
            <br/>That I would hurt,
            <br/>and misunderstand.
            <br/>
            <br/>That I could not know or be known for who I am.
            <br/>
            <br/>Is this the place where I simply said
            <br/><em>"I'm bi"</em>
            <br/>And found I was still standing,
            <br/>still walking,
            <br/>on my way home.
        </Text>
        <Spacer h="10px"/>
            <img src={"https://i.imgur.com/KKj4KmK.jpeg"} alt={"a sunset"} style={{maxWidth:512, justifySelf:"center"}}/>
        </div>
    )
}